import LocalizedStrings, {
  GlobalStrings,
  LocalizedStrings as LocalizedStringsT,
} from "localized-strings";

function withOptions<T>(strings: GlobalStrings<T>): LocalizedStringsT<T> {
  return new LocalizedStrings(strings, {});
}

export const strings = withOptions({
  en: {
    title: "Rx365",
    pharmacyLookup: "Pharmacy Lookup",
    searchBy: "Search by pharmacy name, phone number, or by pharmacy code",
    placeholder: "Search by pharmacy name, phone, or code",
  },
  es: {
    title: "Rx365",
    pharmacyLookup: "Buscar Farmacia",
    searchBy: "Buscar por nombre, número telefónico, o código de farmacia",
    placeholder: "Buscar por nombre, número telefónico, o código de farmacia",
  },
});

export const redirectPage = withOptions({
  en: {
    pharmacyNotFound: "Pharmacy not found.",
  },
  es: {
    pharmacyNotFound: "Farmacia no encontrada",
  },
});

export const redirectModal = withOptions({
  en: {
    title: "Redirect",
    message: "Where would you like to open this page?",
    web: "Web",
    mobile: "Mobile",
  },
  es: {
    title: "Redirigir",
    message: "¿Cómo le gustaría abrir esta página?",
    web: "Sitio Web",
    mobile: "Móvil",
  },
});
